<h2>Pay my mortgage faster</h2>
<form [formGroup]="stepFormGroup">
  <div class="two-fields-form-row">
    <shared-form-field-wrapper label="Current monthly pay">
      <span class="current-value">{{
        currentPropertyMortgageData.mortgageCurrentMonthlyPayment
          | currency: "GBP" : "symbol" : "1.0-0"
      }}</span>
    </shared-form-field-wrapper>
    <shared-form-field-wrapper label="Current term">
      <span class="current-value">{{
        currentPropertyMortgageData.mortgageTermRemaining | term
      }}</span>
    </shared-form-field-wrapper>
  </div>
  <div class="two-fields-form-row">
    <shared-form-field-wrapper
      label="How much extra can you afford each month?"
      [formControl]="stepFormGroup.controls.monthlyPaymentIncrease">
      <shared-input-number
        [type]="InputNumberType.CURRENCY"
        [formControl]="stepFormGroup.controls.monthlyPaymentIncrease" />
    </shared-form-field-wrapper>
    <shared-form-field-wrapper label="New term" [formControl]="stepFormGroup.controls.termInMonths">
      <span class="current-value">{{ stepFormGroup.controls.termInMonths.value | term }}</span>
      <!--      <cp-input-term-->
      <!--        [shortPlaceholder]="true"-->
      <!--        [formControl]="stepFormGroup.controls.termInMonths" />-->
    </shared-form-field-wrapper>
  </div>
  <cp-term-reduction-bar-chart
    [currentTerm]="currentPropertyMortgageData.mortgageTermRemaining"
    [newTerm]="stepFormGroup.controls.termInMonths.value" />
</form>
<cp-stepper
  class="stepper"
  [forwardButtonEnabled]="stepFormGroup.valid"
  [hideProgressBar]="true"
  [showForwardButtonIcon]="false"
  [hideBackButton]="!isBackButtonVisible"
  [showSkipButton]="false"
  (forward)="emitNextClicked()"
  (back)="emitBackClicked()">
  <div class="stepper-content" [class.show-insight]="isShowMoreInsight">
    @if (payMortgageFasterSaving) {
      <div class="button-wrapper">
        <button
          pButton
          class="p-button p-button-primary p-button-sm"
          (click)="isShowMoreInsight = !isShowMoreInsight">
          <label class="pr-2">Insight</label>
          <shared-icon
            fill="white"
            icon="arrow-up"
            [class.rotate]="isShowMoreInsight"
            height="0.5rem"
            width="0.5rem" />
        </button>
      </div>
    }
    @if (isLoadingPayMortgageFasterSaving) {
      <i class="pi pi-spin pi-spinner"></i>
    } @else if (!payMortgageFasterSaving) {
      <p>
        By increasing your payment you can , we can give you insight into how much you could save.
      </p>
    } @else {
      <p [collapse]="isShowMoreInsight" [class.no-margin]="!isShowMoreInsight">
        From the information supplied we anticipate a
        <b>
          reduction in the term of your mortgage of
          {{ payMortgageFasterSaving.newTermInMonths | term }}.
        </b>
      </p>
      <p>
        We anticipate a
        <b class="green">
          saving of {{ payMortgageFasterSaving.savings | currency: "GBP" : "symbol" : "1.0-0" }}
        </b>
        in interest payable over your mortgage term.
      </p>
      <p [collapse]="isShowMoreInsight" [class.no-margin]="!isShowMoreInsight">
        We expect the total amount payable for your <b>mortgage without changes</b> will be
        <b>{{ payMortgageFasterSaving.currentTotalCost | currency: "GBP" : "symbol" : "1.0-0" }}</b>
        and the
        <b>
          total amount payable with your changes will be
          {{ payMortgageFasterSaving.newTotalCost | currency: "GBP" : "symbol" : "1.0-0" }}.
        </b>
      </p>
    }
  </div>
</cp-stepper>
